import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.states, action) {
  switch (action.type) {
    case actionTypes.SET_STATES_DATA:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/states/reducer.js